module.exports = __webpack_public_path__ + "img/7.7447202e.jpg";